import { useTranslation } from "@opendash/i18n";
import { Source } from "@opendash/plugin-parse/dist/types-generated";
import { Modal } from "antd";
import React from "react";
import { Schedule_Execution } from "../../../js/parsegenerated";
import ScheduleExecutionForm from "./ScheduleExecutionForm";

type Props = {
  sources: Source[];
  open?: boolean;
  onClose?: () => void;
  onSaveSuccess?: () => void;
  editExecution?: Schedule_Execution;
};

export default (props: Props) => {
  const t = useTranslation();

  function onClose() {
    if (props.onClose) {
      props.onClose();
    }
  }

  function onSave() {
    if (props.onSaveSuccess) {
      props.onSaveSuccess();
    }
  }

  return (
    <Modal
      open={props.open}
      // onClose={onClose}
      onCancel={onClose}
      title={t("maintenance:schedules.multi-source-schedule-modal.header")}
      width="90%"
      footer={null}
      getContainer={false}
      forceRender
    >
      <ScheduleExecutionForm
        reload={props.open}
        sources={props.sources}
        editExecution={props.editExecution}
        onSaveSuccess={onSave}
      />
    </Modal>
  );
};
